import moment from 'moment';
import _ from 'lodash';
import math from '../../../util/math';
import dateUtils from '../../../util/dates';

export function getStats(data, timeUnit, excludeWeekendOpts, excludeZeroDays) {
  const stats = {};
  const raw = _(data)
    .flatMap(i => {
      return i.data;
    })
    .sortBy('x')
    .groupBy(i => moment(i.x).startOf('month'))
    .map((i, date) => {
      date = new Date(date);
      const data = _(i)
        .groupBy(d => {
          if (timeUnit == 'month') {
            return new Date(d.x).startOfMonth().toISOString();
          } else if (timeUnit == 'week') {
            return new Date(d.x)
              .endOf('week')
              .substract(3)
              .toISOString();
          } else if (timeUnit == '2weeks') {
            const weeksArray = dateUtils.generateWeeksRangeArray(date, date.endOfMonth());
            const week = _.find(weeksArray, w => {
              const date = new Date(d.x);
              return date.isSameOrAfter(w.from) && date.isSameOrBefore(w.to);
            });

            return week ? week.from.toISOString() : 'out-of-range';
          } else {
            return new Date(d.x).endOf(timeUnit).toISOString();
          }
        })
        .map((items, date) => {
          if (!date || date === 'out-of-range') return
          return {
            x: +moment(date)
              .hour(12)
              .minute(0),
            y: _.reduce(
              items,
              (sum, item) => {
                return sum + item.y;
              },
              0
            )
          };
        })
        .compact()
        .value();

      if (!excludeZeroDays) {
        let unit = 1;
        if (timeUnit === 'week') {
          unit = 7;
        } else if (timeUnit === '2weeks') {
          unit = 14;
        } else if (timeUnit == 'month') {
          unit = 30;
        }

        const endOfMonth = moment(date).endOf('month');
        const totalDays = dateUtils.getDays(date, endOfMonth);

        let weekends = 0;
        if (excludeWeekendOpts && excludeWeekendOpts.type) {
          const workingDays = new Date(endOfMonth).diff(date, 'days', excludeWeekendOpts);
          weekends = Math.round((totalDays - workingDays) / unit);
        }

        const zeroDays = Math.round(totalDays / unit) - data.length - weekends;

        for (let i = 0; i < zeroDays; i++) {
          data.push({ y: 0 });
        }
      }

      const mode = math.getModeBy(data, 'y');
      const mean = _.meanBy(data, 'y');
      const median = math.getMedianBy(data, 'y');

      return {
        x: +moment.utc(date).local(),
        mean,
        median,
        mode
      };
    })
    .value();

  stats.mean = _.map(raw, i => {
    return { x: i.x, y: i.mean };
  });
  stats.median = _.map(raw, i => {
    return { x: i.x, y: i.median };
  });
  stats.mode = _.map(raw, i => {
    return { x: i.x, y: i.mode };
  });

  return stats;
};
